const NAME = "BANK_SETTINGS";

export default NAME;
